import CardCarousel from './CardCarousel';

const els = document.querySelectorAll('.card-carousel');

for (let el of els) {
    new CardCarousel(el);
}
